export const CHANGE_PLACE_ID_CAMPAIGN_PLACE_EDITOR = 'CHANGE_PLACE_ID_CAMPAIGN_PLACE_EDITOR';
export type CHANGE_PLACE_ID_CAMPAIGN_PLACE_EDITOR = typeof CHANGE_PLACE_ID_CAMPAIGN_PLACE_EDITOR;

export interface ChangePlaceIdCampaignPlaceEditor {
    type: CHANGE_PLACE_ID_CAMPAIGN_PLACE_EDITOR;
    editorId: string;
    placeId: string;
}

export function changePlaceIdCampaignPlaceEditorAction(
    editorId: string,
    placeId: string
): ChangePlaceIdCampaignPlaceEditor {
    return {
        type: CHANGE_PLACE_ID_CAMPAIGN_PLACE_EDITOR,
        editorId,
        placeId
    };
}
